import { useEffect } from 'react'
import Tr from 'translations/Translations';
import reduxStore from 'redux/store'
import { setSaveStatusError } from 'redux/actions'

const isErrors = (errors) => {
	if (Object.keys(errors).length <= 0) return false;
	for (let k in errors) {
		const e = errors[k];
		if (typeof e === 'object') {
			if(isErrors(e)) return true;
		} else {
			if(e.length > 0) return true;
		}
	}
	return false;
}

function ShowErrorOnFailedSubmit({
	setCheckError,
	checkError,
	formikProps,
	errorMsg
}) {
	useEffect(() => {
		if (checkError) {
			setCheckError(false)
			const errors = formikProps.errors
			if (isErrors(errors)) {
				console.log(errors);
				const msg = !!errorMsg ? errorMsg : Tr('submit_error')
				reduxStore.dispatch(setSaveStatusError(msg));
			}
		}
		// eslint-disable-next-line
	}, [checkError])
	return ''
}

export default ShowErrorOnFailedSubmit;